/**
 * autoVerifyCadence — when the automatic Cashfree check should run again, and when it
 * should stop. PURE (no Firebase, no network, no clock) so it stays unit-testable.
 */

const MIN = 60 * 1000;
const HOUR = 60 * MIN;

/**
 * GIVE-UP WINDOW: an order still unpaid after 3 days is never going to be paid, so the
 * automatic loop stops checking it (stamped `payment.autoCheckStoppedAt` once). It stays
 * visible on the desk for a manual "Verify Now", which always forces a live lookup.
 */
export const AUTO_CHECK_GIVE_UP_MS = 3 * 24 * HOUR;

/**
 * How soon to look again at an order that is NOT yet paid, by its age. A customer pays
 * within minutes of placing the order, so a brand-new order is polled hard and an old
 * one barely at all — that way a successful payment appears on the desk by itself,
 * without a staff member clicking anything.
 */
export const nextCheckDelayForAge = (ageMs) => {
  if (ageMs < 30 * MIN) return MIN;        // just placed — the payment is happening now
  if (ageMs < 3 * HOUR) return 5 * MIN;
  if (ageMs < 24 * HOUR) return 30 * MIN;
  return 2 * HOUR;                          // winding down towards the 3-day give-up
};
